import { useState } from 'react';
import type { IProcessAction } from '../../../../common/interfaces/IProcessAction';
import { ServiceCode } from '../../../../common/enums/ServiceCode';
import { OsasOptInFlowChoice } from './OsasOptInFlowChoice';
import { OsasOptInFlowSuccess } from './OsasOptInFlowSuccess';
import { OsasOptInFlowWaitingForCall } from './OsasOptInFlowWaitingForCall';

export function OsasOptInFlow({ actions }: Readonly<{ actions: IProcessAction[] }>) {
    const [patientClickedContinue, setPatientClickedContinue] = useState(false);

    const osasStartFlowAction = actions.find(
        (action: IProcessAction) =>
            action.service.code === ServiceCode.OSAS && ['Patient start flow in MK'].includes(action.name)
    );

    const osasPatientWantsToBeCalledAction = actions.find(
        (action: IProcessAction) =>
            action.service.code === ServiceCode.OSAS && ['Patient wilt gebeld worden'].includes(action.name)
    );

    if (patientClickedContinue) {
        return <OsasOptInFlowSuccess />;
    }

    if (osasStartFlowAction && osasPatientWantsToBeCalledAction) {
        return (
            <OsasOptInFlowChoice
                osasPatientWantsToBeCalledAction={osasPatientWantsToBeCalledAction}
                osasStartFlowAction={osasStartFlowAction}
                setPatientClickedContinue={setPatientClickedContinue}
            />
        );
    }

    if (osasStartFlowAction) {
        return (
            <OsasOptInFlowWaitingForCall
                osasStartFlowAction={osasStartFlowAction}
                setPatientClickedContinue={setPatientClickedContinue}
            />
        );
    }

    return null;
}
